var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, Paper, Typography, ClickAwayListener, Fade, Popper } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { Category } from './Category';
export var CategorySelector = function (_a) {
    var categories = _a.categories, onSelect = _a.onSelect;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = React.useState(null), current = _c[0], setCurrent = _c[1];
    var arrowRef = React.useRef(null);
    var handleClick = function (event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    var handleClickAway = function () {
        setAnchorEl(null);
    };
    var handleSelect = function (c) {
        setAnchorEl(null);
        setCurrent(c);
        onSelect(c);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'category-selector' : undefined;
    return (React.createElement("div", { className: "category-selector" },
        React.createElement(Button, { className: "category-selector__button", variant: "outlined", "aria-describedby": id, onClick: handleClick, startIcon: React.createElement(ExpandMoreIcon, null) }, (current && current.title) || 'カテゴリで絞る'),
        React.createElement(Popper, { id: id, open: open, anchorEl: anchorEl, transition: true, placement: "bottom-start", disablePortal: false, modifiers: {
                flip: {
                    enabled: true,
                },
                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'scrollParent',
                },
                arrow: {
                    enabled: false,
                    element: arrowRef,
                },
            }, className: "category-selector__popper" }, function (_a) {
            var TransitionProps = _a.TransitionProps;
            return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
                React.createElement(Fade, __assign({}, TransitionProps, { timeout: 350 }),
                    React.createElement("div", { className: "category-selector__wrapper" },
                        React.createElement("div", { className: "arrow", ref: arrowRef }),
                        React.createElement(Paper, { className: "category-selector__paper", square: true },
                            React.createElement(Typography, { variant: "h2", className: "category-selector__title" }, "\u30AB\u30C6\u30B4\u30EA\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"),
                            React.createElement(Category, { categories: categories, onSelect: handleSelect }))))));
        })));
};
//# sourceMappingURL=CategorySelector.js.map